import data from "../../shared/sharedData";

// Commit message from Theo: completed section 6 with proper formatting, also changed degree part to a dropdown menu and no longer and radio button
export default {
  name: "Job Opportunity and Minimum Requirements",
  prefix: "F.a",
  sections: [
    {
      name: "Document Upload - SWA Job Order",
      fields: [
        {
          code: "F.a.1",
          machine_name: "swaJoborderAttached",
          name: "SWA Job Order",
          widget: "file_upload",
          label:
            "<span>You must upload the job order submitted concurrently to the State Workforce Agency (SWA) serving the area of intended employment.</span>",
          fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
          validate: ["required", "checkValue"],
          tooltip:
            "A copy of the job order submitted to the State Workforce Agency (SWA) must be attached to this application.",
        },
        {
          code: "F.a.1",
          machine_name: "files",
          widget: "text",
          hidden: true,
        },
        {
          code: "F.a.2",
          machine_name: "swaJoborderStatename",
          widget: "select",
          label: "Name of the State",
          selection: data.state,
          validate: ["required"],
          tooltip:
            "Enter the name of the State to which the job order was submitted.",
        },
        {
          code: "F.a.3",
          machine_name: "swaJoborderSubmitted",
          widget: "date",
          label: "Date Job Order Submitted",
          validate: ["required"],
          tooltip:
            "Enter the date the job order was submitted to the SWA, using a month/day/year format (mm/dd/yyyy).",
        },
      ],
    },
    {
      name: "Job Duties",
      fields: [
        {
          code: "F.a.4",
          machine_name: "jobDuties",
          widget: "text_area",
          label:
            "Description of the specific services or labor to be performed.<br/><i>(All job duties must be disclosed on this form. One separate attachment will be accepted to fully complete the response.)</i>",
          validate: ["required"],
          message: "This field cannot be more than 4000 characters long.",
          tooltip: `Describe, in detail, the job duties to be performed by any worker filling the job opportunity, including any 
            equipment to be used, any supervisory responsibilities, and other pertinent work tasks. The entry in this field 
            must be the same as the job duties issued by the Department for the employer’s job opportunity on the PWD 
            Form ETA-9141.All job duties must be disclosed in the space allotted on the form. The employer may include 
            one separate attachment where the space allotted is insufficient to fully respond to this collection 
            item. For employers filing electronically, the Department’s electronic filing system will 
            automatically provide the employer with an addendum if the entry exceeds the allotted space on the form. 
            For employers filing applications by mail, the employer must begin its description of the job duties in the 
            allotted space on the form and include one clearly-marked and easy-to-locate separate attachment, if necessary, 
            to fully respond to this collection item.`,
          rows: 8,
          parse: "noBadChars",
          placeholder: "",
          inputLimit: 4000,
        },
      ],
    },
    {
      name: "Document Upload - Job Duties (Optional)",
      fields: [
        {
          code: "F.a.4",
          machine_name: "jobDutiesAttached",
          name: "Additional Job Duties",
          widget: "file_upload",
          label:
            "All Job duties must be disclosed in the space above, however, you may include one separate attachment where the allocated space is insufficient.",
          fileTypes: [".pdf", ".doc", ".docx", ".txt", ".xls", ".xlsx"],
          // validate: ["required", "checkValue"],
          tooltip:
            "You may include one separate attachment where the allocated space is insufficient.",
        },
        {
          code: "F.a.4",
          machine_name: "files",
          widget: "text",
          hidden: true,
        },
      ],
    },
    {
      name: "Anticipated days and hours of work per week",
      fields: [
        {
          isGroup: {
            code: "F.a.5 A-H",
            machine_name: "_anticipated_days_hours",
            label: "(an entry is required for each box below) *</i>",
            tooltip:
              "Use Items 5a through 5h to identify the anticipated days and hours of work per day and per week. Use a numerical (99.99) format for each item below. <u>An entry is required for each box listed in this field.</u>",
            coloring: "grey",
            fields: [
              {
                widget: "anticipated_date",
                label: "Sunday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "jobHoursSun",
                choice: "Sunday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Monday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "jobHoursMon",
                choice: "Monday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Tuesday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "jobHoursTues",
                choice: "Tuesday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Wednesday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "jobHoursWed",
                choice: "Wednesday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Thursday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "jobHoursThu",
                choice: "Thursday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Friday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "jobHoursFri",
                choice: "Friday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Saturday", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "jobHoursSat",
                choice: "Saturday",
                validate: ["required", { maxValue: 24 }, { minValue: 0 }],
                parse: "positiveNumber",
              },
              {
                widget: "anticipated_date",
                label: "Total", // Need Label for Review and Submit Page
                labelHidden: true, // Hides only Label but keeps input
                machine_name: "jobHoursTotal",
                name: "total",
                choice: "Total:",
                validate: [
                  "required",
                  {
                    minValue: 35,
                    message:
                      "Please verify the accuracy of the entries in this section. The job opportunity must offer full-time employment that is at least 35.00 hours per week.",
                  },
                ],
                parse: "positiveNumber",
              },
            ],
          },
        },
      ],
    },
    {
      name: "Hourly work schedule",
      fields: [
        {
          isGroup: {
            tooltip:
              "Use Items 6a and 6b to identify the normal daily work schedule for the job opportunity using the standard time in the area where the work is expected to be performed (e.g., 9 a.m. to 5 p.m., 7 a.m. to 11 a.m., or 4 p.m. to 8 p.m.).",
            label: "<i>(an entry is required for each box below) *</i>",
            coloring: "grey",

            fields: [
              {
                code: "F.a.6a",
                widget: "time",
                label: "Begin Time",
                machine_name: "jobHourStart",
                validate: ["required"],
              },
              {
                code: "F.a.6b",
                widget: "time",
                label: "End Time",
                machine_name: "jobHourEnd",
                validate: ["required"],
              },
            ],
          },
        },
      ],
    },
    {
      name: "Education & Training",
      fields: [
        {
          isGroup: {
            code: "F.a.7",
            label: "Education: minimum U.S. diploma/degree required?",
            machine_name: "jobMinedu",
            tooltip:
              "Identify whether the minimum U.S. diploma or degree required by the employer for the job opportunity is None, HighSchool/GED, Associate’s, Bachelor’s, Master’s, Doctorate (PhD), or Other degree (JD, MD, etc.). Only make one selection. The entry in this field must be the same as the minimum education requirements issued by the Department for the employer’s job opportunity on the PWD Form ETA-9141.",
            coloring: "none",
            required: true,
            fields: [
              {
                widget: "radio",
                choice: "None",
                value: "None",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "High School/GED",
                value: "High School/GED",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Associate's",
                value: "Associate's",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Bachelor's",
                value: "Bachelor's",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Master's",
                value: "Master's",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Doctorate (PhD)",
                value: "Doctorate (PhD)",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Other degree (JD, MD, etc.)",
                value: "Other degree (JD, MD, etc.)",
                validate: ["required"],
              },
            ],
          },
        },
        {
          code: "F.a.8",
          machine_name: "jobMintrainingmonths",
          widget: "text",
          label: "Training: number of <u>months</u> required",
          validate: [
            "required",
            {
              fieldComparison: "jobMintrainingmonths",
              message: "This number should be greater than or equal to 0.",
              needsFieldValues: true,
              extraData: {
                operator: ">=",
                valueOf: 0,
              },
            },
          ],
          maxLength: 4,
          parse: "positiveWholeNumberToInt",
          tooltip: `Indicate the minimum number of months of training required. If no training is required, enter “0” in this field. 
            Training may include, but is not limited to: programs, coursework, or training experience (other than employment). 
            Do not include on-the-job training required by the employer after the date of hire. When answering this question, 
            do not duplicate time requirements that are listed in other fields of this application; the training required should 
            be excluded from fields in Sections F.a.7 and F.a.9 that request information on education or work experience 
            requirements. The entry in this field must be the same as the minimum months of training issued by the Department 
            for the employer’s job opportunity on the PWD ETA-9141.`,
        },
        {
          code: "F.a.9",
          machine_name: "jobMinexpmonths",
          widget: "text",
          label: "Work Experience: number of <u>months</u> required",
          validate: [
            "required",
            {
              fieldComparison: "jobMinexpmonths",
              message: "This number should be greater than or equal to 0.",
              needsFieldValues: true,
              extraData: {
                operator: ">=",
                valueOf: 0,
              },
            },
          ],
          maxLength: 4,
          parse: "positiveWholeNumberToInt",
          tooltip: `Enter the minimum number of months of work experience required for the job opportunity. If there is no minimum work 
            experience requirement, enter a “0” in this field. The entry in this field must be the same as the minimum months of 
            experience issued by the Department for the employer’s job opportunity on the PWD Form ETA-9141.`,
        },
        {
          isGroup: {
            code: "F.a.10",
            label:
              "Supervision: does this position supervise the work of other employees?",
            machine_name: "jobSupervisor",
            tooltip:
              "Mark “Yes” or “No” as to whether the job opportunity supervises the work of other employees.",
            coloring: "none",
            required: true,
            disabled: true,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
                clearSchema: ["jobNumberSup"],
              },
            ],
          },
        },
        {
          code: "F.a.10a",
          machine_name: "jobNumberSup",
          widget: "text",
          label: "Number of employees worker will supervise:",
          maxLength: 4,
          tooltip:
            "If “Yes” is marked in question 10, enter the total number of employees the job opportunity will supervise.",
          validate: [
            "required",
            {
              fieldComparison: "jobNumberSup",
              message: "This is not a valid number",
              needsFieldValues: true,
              extraData: {
                operator: ">=",
                valueOf: 1,
              },
            },
          ],
          parse: "positiveWholeNumber",
          isVisible: {
            when: "jobSupervisor",
            is: "YES",
          },
        },
        {
          code: "F.a.11",
          machine_name: "jobMinspecialreq",
          widget: "text_area",
          label:
            "Special Requirements - List specific skills, licenses/certifications, field(s) of training, and requirements of the job.",
          validate: [
            "required",
            {
              minLength: 2,
              message: "You must describe the job-related special requirements",
            },
          ],
          message: "This field cannot be more than 4000 characters long.",
          tooltip: `Enter the job-related skills, minimum qualifications, field(s) of training, and other special requirements of the job 
            opportunity. Examples include but are not limited to: licenses, including a valid driver’s license; certifications; 
            specific foreign language fluency; proficiency with specific tools, equipment, software, or machinery; proficiency 
            in specific methods (e.g., Churrasco chef skills); travel or relocation requirements; shorthand and typing speeds; 
            ability to pass drug and/or background checks. If a job opportunity requires training as described in Section 
            F.a.8, you must enter in this field the specific field(s) and/or name(s) of the training required. You may 
            list more than one field of training and/or more than one name. If the job opportunity does not require any 
            special requirements, enter “N/A.” <br/> <b>Note:</b> All requirements must be bona fide, and consistent with 
            the normal and accepted qualifications/requirements imposed by non-H-2B employers in the same occupation and 
            area of intended employment. The entry in this field must be the same as the special requirements issued by the 
            Department for the employer’s job opportunity on the PWD Form ETA-9141.`,
          parse: "noBadChars",
          rows: 8,
          placeholder: "",
          inputLimit: 4000,
        },
      ],
    },
  ],
};
